import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Import services:
import {
  ServicioAnalisisService,
  AnalisisServiceEntity,
  AnalisisEntity
} from '../../services/servicio-analisis.service';

import { DataGraficasService } from 'src/app/services/utils/data-graficas.service';
import { DataPermisosService } from 'src/app/services/utils/data-permisos.service';

/**
 * Este reporte es de Fundación Ideal, el cual genera las gráficas
 * de análisis de habilidad registrado en la aplicación web Standard-Health.
 *
 * @author Juan Camilo Martínez Henao
 * @date 8-Marzo-2019
 */

@Component({
  selector: 'app-reporte-analisis-habilidad',
  templateUrl: './reporte-analisis-habilidad.component.html',
  styleUrls: ['./reporte-analisis-habilidad.component.css']
})
export class ReporteAnalisisHabilidadComponent implements OnInit {

  public arrayData: any[] = []; // Se guarda la data de los gráficos.
  public arrayLabels: any[] = []; // Se guarda los Labels de los gráficos.
  public objectAnalisisEntity: AnalisisEntity = { // Este objeto contiene los datos del afiliado que aprece en el reporte.
    identificacion : '',
    nombreCompletoAfiliado: '',
    fechaNacimiento: null,
    celular : '',
    telefono: ''
  };

  private objetoAnalisis: AnalisisServiceEntity = { // Este objeto contendrá los datos para consumir el servicio.
    codigoBaseDatos : '',
    id : ''
  };

  public objetoPermisos: any = { // Este objeto tiene los parámetros que definen los permisos del reporte.
    imprimir : false,
    descargar : false,
    filtros : false
  };

  constructor(private servicioAnalisis: ServicioAnalisisService,
              private dataGrafica: DataGraficasService,
              private activatedRoute: ActivatedRoute,
              private dataPermisos: DataPermisosService
  ) {

    this.activatedRoute.params.subscribe( params => {
      this.objetoAnalisis.codigoBaseDatos = params['codigoBaseDatos'];
      this.objetoAnalisis.id = params['id'];
    });

    this.getPermisos ();
  }

  ngOnInit() {
    this.getResponse();
  }

  /**
   * Este método es el encargado de obtener los permisos y  darle
   * al componente la autorización de que funciones tiene habilitadas.
   */
  public async getPermisos () {

    const ruta: string = await this.activatedRoute.snapshot.url[0].path;
    const result: any = await this.dataPermisos.getPermisos(ruta);

    if ( result != null ) {
      this.objetoPermisos = result;
    }

  }

  /**
   * Este método obtiene los datos del reporte, los cuales son traidos del
   * servicio web generar-reportes-api-rest.
   */
  private async getResponse() {

    try {

      const response = await this.servicioAnalisis.getResponseReporteAnalisis(this.objetoAnalisis);
      const reponseAfiliado = await this.servicioAnalisis.getResponseAfiliado(this.objetoAnalisis);

      if (response != null) {
        response.subscribe((data: any) => {
          this.arrayData = this.dataGrafica.getResponse(data);
          this.arrayLabels = this.dataGrafica.getArrayLabels();
        });
      }

      if (reponseAfiliado != null) {
        reponseAfiliado.subscribe((data: any) => {
          this.objectAnalisisEntity = data;
        });
      }

    } catch (exception) {
      console.log('Reporte Análisis Habilidad: \n' + exception);
    }
  }

  /**
   * Este método es el encargado de darle la funcionalidad al reporte
   * para que pueda ser impreso.
   */
  private getPrint() {

    document.getElementById('print-footer').style.display = 'none';

    const div = document.getElementById('print-br');
    const divTmp = document.createElement('div');

    divTmp.id = 'test';

    for (let index = 0; index < 5; index++) {
      divTmp.appendChild(document.createElement('br'));
    }

    div.appendChild(divTmp);

    window.print();

    div.removeChild(divTmp);

    document.getElementById('print-footer').style.display = 'block';

  }

  /**
   * Este método llama al servicio cada vez que necesite preguntar
   * si se ha actualizado un dato para luegos er representado en el reporte.
   */
  public onGenerated( param: any) {
    this.getResponse();
  }

  /**
   * Este método llama a la funcionalidad de impresión.
   */
  public onImprimirt( param: any) {
    this.getPrint();
  }

}
